import * as toastr from 'toastr'
interface ToastrOpts {
  timeOut?: number
  extendedTimeOut?: number
  showDuration?: number
  hideDuration?: number
  positionClass?: string
  preventDuplicates?: boolean
  newestOnTop?: boolean
  closeButton?: boolean
  closeHtml?: string
  tapToDismiss?: boolean
  onHidden?: () => void
}

const mainOpts: ToastrOpts = {
  timeOut: 8000,
  extendedTimeOut: 8000,
  positionClass: 'toast-top-right',
  hideDuration: 10,
  newestOnTop: false,
  closeButton: true,
  closeHtml: '<button><i class="toast-close-icon"></i></button>',
  tapToDismiss: false,
}

const persistentOpts: ToastrOpts = {
  timeOut: 0,
  extendedTimeOut: 0,
  tapToDismiss: false,
  closeButton: true,
}

const MAX_TOASTS = 5

export function infoToast(text: string, options?: ToastrOpts): void {
  baseToast('info', text, null, { ...mainOpts, ...options })
}

export function successToast(text: string, options?: ToastrOpts): void {
  baseToast('success', text, null, { ...mainOpts, ...options })
}

export function paramsSuccessToast(text: string, options?: ToastrOpts): void {
  baseToast('success', text, null, { ...persistentOpts, ...options })
}

export function paramsErrorToast(text: string, options?: ToastrOpts): void {
  baseToast('error', text, null, { ...persistentOpts, ...options })
}

export function paramsInfoToast(text: string, options?: ToastrOpts): void {
  baseToast('info', text, null, { ...persistentOpts, ...options })
}

export function couponToast(text: string, options?: ToastrOpts): void {
  baseToast(
    'success',
    text,
    'Coupon Applied',
    Object.assign(
      { iconClass: 'toast-coupon' },
      mainOpts,
      persistentOpts,
      options
    )
  )
}

export function errorToast(text: string, options?: ToastrOpts): void {
  baseToast('error', text, null, { ...mainOpts, ...options })
}

export function warningToast(text: string, options?: ToastrOpts): void {
  baseToast('warning', text, null, { ...mainOpts, ...options })
}

export function removeToasts(): void {
  toastr.remove()
}

export function clearToast(toasts: JQuery): void {
  toastr.clear(toasts)
}

function baseToast(
  type: string,
  text: string,
  title: string,
  options?: ToastrOpts
): void {
  if (toastCount() >= MAX_TOASTS) {
    removeToasts()
  }
  toastr[type](text, title, options)
}

function toastCount(): number {
  const container = toastr.getContainer()
  if (!container) return 0

  const el = container[0]
  if (!el) return 0

  return el.querySelectorAll('.toast').length
}
